import React from "react";
import SubHeader from "../layout/subheader";
import MarkdownView from "../shared/markdown/MarkdownView";

const Imprint = (): JSX.Element => {
  const handleEmail = (email: string) => {
    window.location.href = `mailto:${encodeURIComponent(email)}`;
  };

  const contactEmail = "info(at)minebea-intec.com";
  const dataProtectionEmail = "ralf.weydt(at)nmb-minebea.com";

  const text = `
### Company Head Office

Hamburg

 

### Registry Court

Registergericht Hamburg

HRB-No. 51879

VAT DE 811 354675

 

### Registration Numbers according European WEEE Directive

Minebea Intec Bovenden GmbH & Co. KG:

WEEE-Reg.-No. DE 58091735

Minebea Intec Aachen GmbH & Co. KG:

WEEE-Reg.-No. DE46634365

Minebea Intec GmbH:

WEEE-Reg.-No. DE86199692

 

### Registration Numbers according European Battery Directive

Minebea Intec Bovenden GmbH & Co. KG:

Battery-Reg.-No. DE 97208315“

 

### Managing Directors

Jörg Hoffmann

Peter Grimley

Dr. Karl Christoph Sommer

 

### EU Data Protection Officer

Mr. Ralf Weydt, 

LL.M. Attorney at Law, 

Head of EU Legal Department 

c/o NMB-Minebea-GmbH 

Siemensstraße 30 

63225 Langen, Germany `;

  return (
    <>
      <SubHeader header="Imprint" />
      <div className="row">
        <div className="col hmi-inner-content imprint">
          <h3>Contact</h3>
          <p>Minebea Intec GmbH</p>
          <p>Meiendorfer Strasse 205 A</p>
          <p>22145 Hamburg, Germany</p>
          <p>Telefon: +49.40.67960.303</p>
          <p>Fax: +49.40.67960.383</p>
          <p>
            E-Mail:
            <button
              type="button"
              className="imprint"
              onClick={() => handleEmail(contactEmail)}
            >
              {contactEmail}
            </button>
          </p>
          <MarkdownView displayedMarkdown={text} />
          <p>
            E-Mail:
            <button
              type="button"
              className="imprint"
              onClick={() => handleEmail(dataProtectionEmail)}
            >
              {dataProtectionEmail}
            </button>
          </p>
        </div>
      </div>
    </>
  );
};
export default Imprint;
